// ---------------------------------------------------------------------------
// AppLock — Tier 1: Passthrough storage adapter
// ---------------------------------------------------------------------------
import { LocalStorageBackend } from './storage-backend.js';
import { META_KEYS } from '../core/config.js';
/**
 * Passthrough (Tier 1) storage.
 *
 * Wraps a `StorageBackend` in the async `StorageAdapter` interface
 * without any transformation. Data is stored as-is in cleartext.
 *
 * The async interface exists for API compatibility with the encrypted
 * adapter, so consuming apps don't need to change code when switching tiers.
 */
export class PassthroughStorage {
    constructor(backend) {
        this.backend = backend ?? new LocalStorageBackend();
    }
    async save(key, data) {
        await this.backend.setItem(key, JSON.stringify(data));
    }
    async load(key) {
        const raw = await this.backend.getItem(key);
        if (raw === null)
            return null;
        try {
            return JSON.parse(raw);
        }
        catch {
            // If the value isn't valid JSON, return it as a string
            return raw;
        }
    }
    async remove(key) {
        await this.backend.removeItem(key);
    }
    async keys() {
        const allKeys = await this.backend.getAllKeys();
        return allKeys.filter((key) => !META_KEYS.includes(key));
    }
    async clear() {
        const allKeys = await this.backend.getAllKeys();
        const toRemove = allKeys.filter((key) => !META_KEYS.includes(key));
        for (const key of toRemove) {
            await this.backend.removeItem(key);
        }
    }
}
//# sourceMappingURL=passthrough.js.map